import React from "react";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import {
  ComisionesDeportivaAppGestionDispatcher,
  comisionesDeportivaAppGestionDispatcher
} from "./ComisionesDeportivaAppGestion.dispatcher";
import {
  comisionesDeportivaAppGestionStore,
  ComisionesDeportivaAppGestionStore
} from "./ComisionesDeportivaAppGestion.store";
import ComisionesDeportivaAppGestion from "../../components/comisionesDeportivaAppGestion";

interface Props
  extends ComisionesDeportivaAppGestionStore,
    ComisionesDeportivaAppGestionDispatcher {}

interface State {}

@ReduxConnect(
  comisionesDeportivaAppGestionStore,
  comisionesDeportivaAppGestionDispatcher
)
export default class ComisionesDeportivaAppGestionPage extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Helmet title="Gestión App Deportiva" />
        <Layout>
          <ComisionesDeportivaAppGestion {...this.props} />
        </Layout>
      </main>
    );
  }
}
